module.exports = __webpack_public_path__ + "static/media/arushi.5b207b6c.jpg";